import { students } from "../data";
import heroBg from "../assets/bg/bg-hero-2.webp";

const studentImages = [
  "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=500",
  "https://images.unsplash.com/photo-1544717305-2782549b5136?w=500",
  "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=500",
  "https://images.unsplash.com/photo-1588072432836-e10032774350?w=500",
];

export default function Students() {
  return (
    <div>
      {/* HERO SECTION */}
      <div
        className="page-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(17,29,24,0.78), rgba(17,29,24,0.78)), url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
        
<small
  style={{
    display: "inline-block",
    background: "#dc2626",
    color: "#fff",
    padding: "9px 18px",
    borderRadius: "30px",
    fontSize: "0.85rem",
    fontWeight: 800,
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    boxShadow: "0 6px 20px rgba(220,38,38,0.45)",
    border: "2px solid rgba(255,255,255,0.4)",
    animation: "pulseRed 1.5s infinite",
  }}
>
  🚧 Page is Under Construction
</small>

          <h1
            className="display-lg"
            style={{
              marginTop: "0.5rem",
              marginBottom: "0.75rem",
              color: "var(--gold-light)",
            }}
          >
            Enrolled Students
          </h1>
          <p style={{ color: "rgba(255,255,255,0.85)" }}>
            Meet the brilliant young minds of our community...
          </p>
        </div>
      </div>

      <div className="ribbon-divider" />

      <section className="section">
        <div className="container">
          {students.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "3rem",
                color: "#777",
              }}
            >
              No students found.
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1.2rem",
                maxWidth: "900px",
                margin: "0 auto",
              }}
            >
              {students.map((student, index) => (
                <div
                  key={student.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1.5rem",
                    background: "#fff",
                    borderRadius: "22px",
                    padding: "1rem 1.4rem",
                    boxShadow: "0 10px 28px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(27,67,50,0.08)",
                    transition: "0.3s",
                    flexWrap: "wrap",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 18px 35px rgba(0,0,0,0.12)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 28px rgba(0,0,0,0.08)";
                  }}
                >
                  <img
                    src={studentImages[index % studentImages.length]}
                    alt={student.name}
                    style={{
                      width: "110px",
                      height: "110px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "5px solid #D4A017",
                      flexShrink: 0,
                    }}
                  />

                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "10px",
                      }}
                    >
                      <h3
                        style={{
                          margin: 0,
                          fontSize: "1.45rem",
                          fontWeight: 700,
                          color: "#1B4332",
                        }}
                      >
                        {student.name}
                      </h3>
                      <span
                        style={{
                          background: "#1B4332",
                          color: "#fff",
                          padding: "6px 15px",
                          borderRadius: "50px",
                          fontSize: "0.85rem",
                          fontWeight: 600,
                        }}
                      >
                        {student.class}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit,minmax(160px,1fr))",
                        gap: "1rem",
                        marginTop: "1rem",
                        color: "#555",
                        fontSize: "0.95rem",
                      }}
                    >
                      <div>
                        <strong style={{ color: "#1B4332" }}>Age</strong>
                        <br />
                        {student.age} Years
                      </div>
                      <div>
                        <strong style={{ color: "#1B4332" }}>School</strong>
                        <br />
                        {student.school}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}